import { all, fork } from "redux-saga/effects";
import authSaga from "./saga/authsaga";
import orgSaga from "./saga/organizationSaga";
import UserSaga from "./saga/userSaga";
import rootDashboardSaga from "./saga/dashboardSaga";
import rootUserManagementSaga from "./saga/userManagementSaga";
import rootInnerCircleSaga from "./saga/innerCircleSaga";
import CommunitySaga from "./saga/communitySaga";
import ReportSaga from "./saga/reportSaga";
import rootAdminSaga from "./saga/adminSaga";
import EncouragementgroupsSaga from "./saga/encouragementgroupsSaga";
import rootMessagesSaga from "./saga/messageSaga";
import rootNotificationSaga from "./saga/notificationSaga";
import rootSettingSaga from "./saga/settingSaga";
import rootAdminInnerCircleSaga from "./saga/adminInnerSaga";
import rootToolsSaga from "./saga/toolsSaga";
import commonSaga from "./saga/commonSaga";
import departmentSaga from "./saga/departmentSaga";
import directCareSaga from "./saga/directCareSaga";
import manageProsSaga from "./saga/manageProsSaga";
import createUserSaga from "./saga/createUser";
import EngagementFarmingSaga from "./saga/engagementFarming";
import rootSubscriptionSaga from "./saga/subscriptionsSaga"

export default function* rootSaga() {
  yield all([fork(authSaga)]);
  yield all([fork(orgSaga)]);
  yield all([fork(UserSaga)]);
  yield all([fork(rootUserManagementSaga)]);
  yield all([fork(rootDashboardSaga)]);
  yield all([fork(rootInnerCircleSaga)]);
  yield all([fork(CommunitySaga)]);
  yield all([fork(ReportSaga)]);
  yield all([fork(rootAdminSaga)]);
  yield all([fork(EncouragementgroupsSaga)]);
  yield all([fork(rootMessagesSaga)]);
  yield all([fork(rootNotificationSaga)]);
  yield all([fork(rootSettingSaga)]);
  yield all([fork(rootAdminInnerCircleSaga)]);
  yield all([fork(rootToolsSaga)]);
  yield all([fork(commonSaga)]);
  yield all([fork(departmentSaga)]);
  yield all([fork(directCareSaga)]);
  yield all([fork(manageProsSaga)]);
  yield all([fork(createUserSaga)]);
  yield all([fork(EngagementFarmingSaga)]);
  yield all([fork(rootSubscriptionSaga)]);
}
